/** Values below this are treated as Unix seconds; at/above as milliseconds. */
const UNIX_MS_THRESHOLD = 1e12;

export function coerceApiUnixTimestampToMs(
  value: string | number | null | undefined,
): number | null {
  if (value == null || value === "") {
    return null;
  }

  const numeric =
    typeof value === "number"
      ? value
      : /^\d+$/.test(String(value).trim())
        ? Number(String(value).trim())
        : Number.NaN;

  if (!Number.isFinite(numeric)) {
    return null;
  }

  return numeric < UNIX_MS_THRESHOLD ? numeric * 1000 : numeric;
}

export function coerceApiUnixTimestampToIso(
  value: string | number | null | undefined,
): string | null {
  const ms = coerceApiUnixTimestampToMs(value);
  return ms == null ? null : new Date(ms).toISOString();
}
